import { jsx as _jsx, jsxs as _jsxs } from "react/jsx-runtime";
import * as styles from "./Avatar.css.js";
// Up to two initials from a display name ("Sam Lee" → "SL", "alice" → "A").
export const initialsOf = (name) => name
    .trim()
    .split(/\s+/)
    .slice(0, 2)
    .map((w) => w[0]?.toUpperCase() ?? "")
    .join("") || "?";
const GRADIENT_KEYS = ["g0", "g1", "g2", "g3", "g4"];
// Deterministic hash so a given name always maps to the same gradient variant.
const gradientKeyFor = (name) => {
    let hash = 0;
    for (let i = 0; i < name.length; i++)
        hash = (hash * 31 + name.charCodeAt(i)) | 0;
    return GRADIENT_KEYS[Math.abs(hash) % GRADIENT_KEYS.length];
};
// A circular avatar: the photo if present, otherwise a gradient with initials. Labelled
// by name (native title tooltip on hover).
export const Avatar = ({ name, photoUrl, size = "md", decorative = false }) => (_jsx("span", { className: [styles.base, styles.size[size], photoUrl === undefined ? styles.gradient[gradientKeyFor(name)] : ""]
        .filter(Boolean)
        .join(" "), ...(decorative ? { "aria-hidden": true } : { role: "img", "aria-label": name, title: name }), children: photoUrl !== undefined ? _jsx("img", { className: styles.image, src: photoUrl, alt: "" }) : initialsOf(name) }));
// Overlapping avatars with a "+N" bubble when there are more than `max`.
export const AvatarStack = ({ people, max = 4, size = "md" }) => {
    const shown = people.slice(0, max);
    const extra = people.length - shown.length;
    return (_jsxs("span", { className: [styles.stack, size === "xs" ? styles.stackXs : ""].filter(Boolean).join(" "), children: [shown.map((p, i) => (_jsx(Avatar, { name: p.name, ...(p.photoUrl !== undefined ? { photoUrl: p.photoUrl } : {}), size: size }, `${p.name}-${i}`))), extra > 0 && (_jsxs("span", { className: [styles.base, styles.size[size], styles.overflow].join(" "), "aria-label": `${extra} more`, title: `${extra} more`, children: ["+", extra] }))] }));
};
//# sourceMappingURL=Avatar.js.map